import React from "react";
import { Button, Card, Stack, Typography } from "@mui/joy";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";
import { Link as RouterLink } from "react-router-dom";

import PageHero from "../components/common/PageHero";
import DonationForm from "../components/Donation/DonationForm";

export default function AddDonation() {
  return (
    <Stack spacing={3} sx={{ pb: 2 }}>
      <PageHero
        eyebrow="Record seva"
        title="Log a new donation"
        description="Capture each act of generosity so devotees receive their blessings and receipts promptly."
        actions={[
          <Button key="back" variant="plain" color="neutral" component={RouterLink} to="/donations" startDecorator={<ArrowBackRoundedIcon />}>
            Back to donations
          </Button>,
        ]}
      />

      <Card
        variant="outlined"
        sx={{
          borderRadius: "xl",
          p: { xs: 2.5, md: 4 },
          display: "flex",
          flexDirection: "column",
          gap: 2.5,
        }}
      >
        <Stack spacing={0.5}>
          <Typography level="title-md" sx={{ fontWeight: 700 }}>
            Devotee details
          </Typography>
          <Typography level="body-sm" sx={{ color: "text.secondary" }}>
            Log contact information, seva preferences, and payment method in a single devotional record.
          </Typography>
        </Stack>

        <DonationForm />

        <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start" sx={{ pt: 1 }}>
          <FavoriteRoundedIcon color="primary" fontSize="small" />
          <Typography level="body-xs" sx={{ color: "text.tertiary" }}>
            Every saved donation helps us acknowledge devotees with gratitude and timely receipts.
          </Typography>
        </Stack>
      </Card>
    </Stack>
  );
}
